export var RequestStatus;
(function (RequestStatus) {
    RequestStatus["pending"] = "pending";
    RequestStatus["declined"] = "declined";
    RequestStatus["approved"] = "approved";
})(RequestStatus || (RequestStatus = {}));
